<script lang=ts>
  let { children = undefined, class: className = "" } = $props()

</script>


<div class="{className == "" ? "w-full mb-4 mt-8 text-xl md:text-2xl" : className } font-[300] text-[var(--df-primary)] ">{@render children?.()}</div>
